module.exports = __webpack_public_path__ + "static/media/7.6ea65520.JPG";